// Modules
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';
import Tooltip from 'praece-react-bootstrap/lib/Tooltip';
import OverlayTrigger from 'praece-react-bootstrap/lib/OverlayTrigger';


// Component
export default class TooltipComponent extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    elementType: PropTypes.any,
    title: PropTypes.node,
    trigger: PropTypes.array,
    placement: PropTypes.string,
    tooltipClasses: PropTypes.string,
    alwaysShow: PropTypes.bool
  };

  constructor() {
    super();
    this.getOverlay = this.getOverlay.bind(this);
    this.getInnerElement = this.getInnerElement.bind(this);
  }

  getOverlay() {
    return (
      <Tooltip id={_.uniqueId('tooltip-')} className={this.props.tooltipClasses}>
        {this.props.title}
      </Tooltip>
    );
  }

  // Legacy code to allow tooltips defined in codebase back when we used the old
  // bootstrap tooltips to work now that we're using react-bootstrap
  getInnerElement() {
    const { className, elementType, children, ...props } = this.props;
    const passedProps = _.omit(props, ['title', 'dispatch', 'trigger', 'placement', 'tooltipClasses']);
    const classes = classNames(className, 'tooltip-container');

    const ElementType = elementType || 'div';

    return (
      <ElementType {..._.omit(passedProps, ['alwaysShow'])} className={classes}>
        {children}
      </ElementType>
    );
  }

  render() {
    const { trigger, placement, alwaysShow } = this.props;

    // If no tooltip title was provided, don't include the overlay trigger & tooltip (otherwise an empty tooltip will show)
    if (!this.props.title) return this.getInnerElement();

    return (
      <OverlayTrigger
        trigger={alwaysShow ? [] : trigger || ['hover', 'focus']}
        defaultOverlayShown={alwaysShow}
        overlay={this.getOverlay()}
        placement={placement || 'top'}
      >
        {this.getInnerElement()}
      </OverlayTrigger>
    );
  }
}
